<h1 class="page-title">Barátaink</h1>

<p>
  A helyi keresztény gyülekezetekkel, közösségekkel összefogásra törekszünk. Támogatjuk, segítjük egymás munkáját.
  Jézus mondja:
</p>

<p class="quote scripture">
  <span class="text">
    "Ahogy én szeretlek titeket, nektek is úgy kell szeretnetek egymást! Erről ismeri majd fel mindenki, hogy az én
    taítványaim vagytok, ha szeretitek egymást."
  </span>
  <span class="location">János evangéliuma 13:34-35</span>
</p>

<p>
  Úgy gondoljuk, hogy Isten igazi gyülekezete nem egy felekezet, vagy egyház, hanem azon emberek összessége, akik igazán
  hisznek Őbenne, és őket nem a vallásuk, vagy szokások tartják össze, hanem a szeretet. Az a szeretet, mely Istentől
  jön, és amely nem változik soha és el sem fogyhat.
</p>

<p>
  Mindezek fényében fontosnak tartjuk, hogy más keresztény emberekkel, gyülekezetekkel, szervezetekkel együtt működjünk,
  támogassuk egymást.
</p>

<section class="friends">
  <div class="friend">
    <p>
      <img alt="Forrás Alapítvány logója" src="/assets/forras.jpg"/>
      Közösségünk tagjai alapították a Forrás Alapítványt, melyet támogatunk, munkáját segítjük.
      Az alapítvány gyakorlati tevékenységet folytat a városunkban élő emberek boldogulása érdekében.
    </p>

    <p class="quote scripture">
      <span class="text">
        "Munkálkodjatok a városotok jólétén és békességén... imádkozzatok érte az Úrhoz, mert annak jóléte lesz a ti
        jólétetek."
      </span>
      <span class="location">Jeremiás könyve 29:7</span>
    </p>

    <p class="jump-btn">
      <a class="btn btn-outline-info" href="http://www.forrasalapitvany.hu/" target="_blank">
        Ugrás a honlapjukra
      </a>
    </p>
  </div>

  <div class="friend">
    <p>
      <img alt="A Biblia Szól gyülekezet" src="/assets/mbsze.png"/>
      Szorosan együttműködünk a Greater Grace World Outreach (Nagyobb Kegyelem Világevangélizációs Szolgálat) keresztény
      gyülekezettel, mely jelenleg több, mint 150 országban hirdeti Jézus Krisztus örömhírét.
      Magyarországon A Biblia Szól Egyház néven ismertek.
    </p>

    <p class="jump-btn">
      <a class="btn btn-outline-info" href="http://bibliaszol.hu/" target="_blank">
        Ugrás a honlapjukra
      </a>
    </p>
  </div>

  <div class="friend">
    <p>
      <img alt="A szegedi Biblia Szól gyülekezet" src="/assets/mbsze-szeged.png"/>
      A Biblia Szól Egyház szegedi gyülekezete.
    </p>

    <p class="jump-btn">
      <a class="btn btn-outline-info" href="http://www.szeged.bibliaszol.hu/" target="_blank">
        Ugrás a
        honlapjukra
      </a>
    </p>
  </div>

  <div class="friend">
    <p>
      <img alt="A kaposvári Békevár Baptista gyülekezet" src="/assets/bekevar.jpg"/>
    </p>

    <p class="jump-btn">
      <a class="btn btn-outline-info" href="http://www.bekevar.hu/" target="_blank">
        Ugrás a honlapjukra
      </a>
    </p>
  </div>

  <div class="friend">
    <p>
      <img alt="Magyar Keresztény Motorosok Közössége" src="/assets/mkmk.png"/>
      Egy nagyszerű motoros "banda", gyülekezetünkből többen is jó barátai ennek a közösségnek.
    </p>

    <p class="jump-btn">
      <a class="btn btn-outline-info" href="http://www.keresztenymotorosok.hu/" target="_blank">
        Ugrás ahonlapjukra
      </a>
    </p>
  </div>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/friends/friends.component.html